import React, { useEffect } from "react";
import posthog from "posthog-js";
import { constant } from "@app/utils/constant";

function ThirdPartyService() {
  useEffect(() => { 
    if (!document.getElementById("cookie_script-js")) {
      const cookieScript = document.createElement("script");
      //cookieScript.src = "//cdn.cookie-script.com/s/6e49ea5fa8d4724c8409a2e4726278d3.js";
      cookieScript.src = "//cdn.cookie-script.com/s/d94f2440d50ff15ac0603b8f0ec0d96c.js";
      cookieScript.id = "cookie_script-js";
      cookieScript.async = true;
      document.head.appendChild(cookieScript);
    } 
    const getCookieScriptConsent = () => {
      const cookie = document.cookie
        .split("; ")
        .find((row) => row.startsWith("CookieScriptConsent="));
      if (!cookie) return null;
      try {
        return JSON.parse(decodeURIComponent(cookie.split("=")[1]));
      } catch {
        return null;
      }
    };

    // --- Initialize PostHog ---
    const initPosthog = () => {
      if (constant.POSTHOG_TRACKING && constant.POSTHOG_TRACKING_CODE) {
        if (!posthog.__initialized) {
          posthog.init(constant.POSTHOG_TRACKING_CODE, {
            api_host: "https://us.i.posthog.com",
            person_profiles: "always",
          });
          posthog.__initialized = true;
          console.log("PostHog initialized");
        }
      }
    };

    // --- Disable PostHog completely ---
    const removePosthog = () => {
      try {
        posthog.opt_out_capturing();
        posthog.reset();

        [localStorage, sessionStorage].forEach((storage) => {
          Object.keys(storage).forEach((key) => {
            if (key.includes("ph_") || key.includes("posthog")) {
              storage.removeItem(key);
            }
          });
        });

        document.cookie.split(";").forEach((cookie) => {
          const name = cookie.split("=")[0].trim();
          if (name.startsWith("ph_") || name.includes("posthog")) {
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
          }
        });

        console.log("PostHog disabled & data cleared");
      } catch (err) {
        console.warn("Error while disabling PostHog:", err);
      }
    }; 
    const consent = getCookieScriptConsent();
    if (consent?.action === "accept") {
      initPosthog();
    } else if (consent?.action === "reject") {
      removePosthog();
    } else {
      console.log("Waiting for user to accept or reject cookies...");
    }

    // --- Listen for consent changes ---
    const handleAccept = () => {
      console.log("CookieScriptAcceptAll event triggered");
      initPosthog();
    };

    const handleReject = () => {
      console.log("CookieScriptRejectAll event triggered");
      removePosthog();
    };

    window.addEventListener("CookieScriptAcceptAll", handleAccept);
    window.addEventListener("CookieScriptRejectAll", handleReject);
 initPosthog();
    return () => {
      window.removeEventListener("CookieScriptAcceptAll", handleAccept);
      window.removeEventListener("CookieScriptRejectAll", handleReject);
    };
   
  }, []);

  return null;
}

export default ThirdPartyService;
